import React from 'react';
import { WorkItem } from '../../types';
import { InlineEditTags } from './InlineEditTags';
import { InlineEditNotes } from './InlineEditNotes';
import { InlineEditStatus } from './InlineEditStatus';
import { db } from '../../services/database';

interface TagsCellProps {
  item: WorkItem;
  onUpdate: (item: WorkItem) => void;
  savedTags: string[];
}

export const TagsCell = React.memo<TagsCellProps>(({ item, onUpdate, savedTags }) => {
  const handleSave = React.useCallback(async (newTags: string[]) => {
    const updatedItem = { ...item, tags: newTags };
    await db.saveWorkItem(updatedItem);
    onUpdate(updatedItem);
  }, [item, onUpdate]);

  return (
    <InlineEditTags
      tags={item.tags || []}
      onSave={handleSave}
      savedTags={savedTags}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison to prevent unnecessary re-renders
  return (
    prevProps.item.id === nextProps.item.id &&
    JSON.stringify(prevProps.item.tags) === JSON.stringify(nextProps.item.tags) &&
    JSON.stringify(prevProps.savedTags) === JSON.stringify(nextProps.savedTags)
  );
});

interface NotesCellProps {
  item: WorkItem;
  onUpdate: (item: WorkItem) => void;
}

export const NotesCell = React.memo<NotesCellProps>(({ item, onUpdate }) => {
  const handleSave = React.useCallback(async (newDescription: string) => {
    const updatedItem = { ...item, description: newDescription };
    await db.saveWorkItem(updatedItem);
    onUpdate(updatedItem);
  }, [item, onUpdate]);

  return (
    <InlineEditNotes
      value={item.description || ''}
      onSave={handleSave}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison to prevent unnecessary re-renders
  return (
    prevProps.item.id === nextProps.item.id &&
    prevProps.item.description === nextProps.item.description
  );
});

interface StatusCellProps {
  item: WorkItem;
  onUpdate: (item: WorkItem) => void;
}

export const StatusCell = React.memo<StatusCellProps>(({ item, onUpdate }) => {
  const handleSave = React.useCallback(async (newStatus?: any) => {
    const updatedItem = { ...item, status: newStatus };
    await db.saveWorkItem(updatedItem);
    onUpdate(updatedItem);
  }, [item, onUpdate]);

  return (
    <InlineEditStatus
      value={item.status}
      onSave={handleSave}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison to prevent unnecessary re-renders
  return (
    prevProps.item.id === nextProps.item.id &&
    prevProps.item.status === nextProps.item.status
  );
});